import { useMemo } from 'react'

interface Props {
  min?: number
  max?: number
  current: number
}

const useProgress = ({ min, max, current }: Props) => {
  const { _min, _max } = useMemo(() => {
    return {
      _min: min ?? 0,
      _max: max ?? 100
    }
  }, [min, max])

  const percent = useMemo(() => {
    const progress = Math.min(100, Math.floor(Math.max(_min, current) / _max * 100))
    return `${progress}%`
  }, [_min, _max, current])

  return percent
}

export default useProgress
